/**
 * The business behind iBigDo, as the footer and the legal pages (Terms, Privacy, Refund & Cancellation, Security & Data)
 * show it. One place to change.
 */
const COMPANY = {
  brand: 'iBigDo',
  legalName: 'iBigDo Technologies',
  address: 'D34, Sector 48, Noida, Uttar Pradesh, India',
  supportEmail: 'care@ibigdo.com',
  // Named under India's Digital Personal Data Protection Act for privacy questions and complaints
  grievanceOfficer: { name: 'Grievance Officer', email: 'care@ibigdo.com' },
  // Courts with jurisdiction over disputes under the Terms
  jurisdictionCity: 'Noida, Uttar Pradesh',
  // How long an organization's data is kept after its plan ends or it closes its account, for export on request
  dataKeptDaysAfterEnd: 90,
  // Shown as "Last updated" on every legal page; change it whenever their wording changes
  legalUpdated: '4 November 2026'
};

export default COMPANY;
